{
  "name": "@ns/data-edit-record",
  "version": "1.2.0",
  "authorable": true,
  "description": "Change one record's mapped fields, while the job is open. A second set it covers is what its reference fields pick from.",
  "inputs": {
    "SET": {
      "type": "string",
      "ref": "dataSet"
    },
    "RECORD": {
      "type": "string",
      "ref": "dataRecord",
      "access": "EDIT",
      "in": "SET"
    },
    "FIELDS": {
      "type": "array",
      "fieldsOf": "SET"
    },
    "LINKED_SET": {
      "type": "string",
      "ref": "dataSet",
      "access": "READ",
      "optional": true,
      "linked": true
    },
    "LINKED_FIELDS": {
      "type": "array",
      "fieldsOf": "LINKED_SET",
      "optional": true
    },
    "PROMPT": {
      "type": "string",
      "optional": true
    }
  },
  "outcomes": {
    "saved": {}
  }
}
